import { useQuery } from "@tanstack/vue-query"
import { createCrystallizeQueryOptions } from "~/utilities/crystallize"

export function useEcommerceCatalogue() {
  const version = useCrystallizeVersion()
  return useQuery({
    ...createCrystallizeQueryOptions(version, "/"),
    select(data) {
      const map = new Map<string, CrystallizeProductVariant>()

      if (data) {
        if (data.type !== "folder") {
          throw new Error("Expected root catalogue to be a folder")
        }

        for (const product of data.children) {
          if (product.type !== "product") {
            continue
          }

          for (const variant of product.variants) {
            map.set(variant.sku, variant)
          }
        }
      }

      return map
    },
  })
}
